import api from "@/lib/api";
import log from "@/lib/log";
import { attributionPayload } from "@/lib/attribution";

export function track(event, label) {
  try {
    api.post("/track", { event, label: label || null, attribution: attributionPayload() }).catch((e) => log.debug("Analytics event dropped", event, e));
  } catch (e) {
    log.debug("Analytics unavailable", e);
  }
}
